import { useEffect } from "react";

function blockSensitiveClipboardEvent(event: ClipboardEvent): void {
    const target = event.target as HTMLElement | null;
    if (target && target.hasAttribute("data-disable-copy-paste")) {
        event.preventDefault();
    }
}

export function useDisableCopyPaste(): void {
    useEffect(() => {
        document.addEventListener("copy", blockSensitiveClipboardEvent);
        document.addEventListener("cut", blockSensitiveClipboardEvent);
        document.addEventListener("paste", blockSensitiveClipboardEvent);

        return () => {
            document.removeEventListener("copy", blockSensitiveClipboardEvent);
            document.removeEventListener("cut", blockSensitiveClipboardEvent);
            document.removeEventListener("paste", blockSensitiveClipboardEvent);
        };
    }, []);
}
